import React, { useState } from 'react'
import batteryico from '../icons/batteryFull.svg'


const RightNavPanel = ({handleBrightness, handleVolume, brightness, volume, nightLightHandle, night}) => {
  const [wifi, setWifi] = useState(false);
  const [blutooth, setBluetooth] = useState(false);
  const [airplane, setAirplane] = useState(false);
  const [dark, setDark] = useState(false);
  const [focus, setFocus] = useState(false);
  const [location, setLocation] = useState(false);
  const [connect, setConnect] = useState(false);
  const [transparency, setTransparency] = useState(false);
 


  return (
    <div>
      <div className="multiPanel bg-white bg-opacity-80 rounded-md p-5 h-[30rem] w-[25rem] shadow-md shadow-black/40">
        <div className="toggles grid gap-3 grid-cols-3">

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{wifi? setWifi(false): setWifi(true)}} className={`h-[60px] w-[115px] rounded-md ${wifi? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${wifi? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-sharp fa-solid fa-wifi"></i>
            </span>
            <span className='text-sm pt-1'>Wifi</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{blutooth? setBluetooth(false): setBluetooth(true)}} className={`h-[60px] w-[115px] rounded-md ${blutooth? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${blutooth? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-brands fa-bluetooth-b"></i>
            </span>
            <span className='text-sm pt-1'>Bluetooth</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{airplane? setAirplane(false): setAirplane(true)}} className={`h-[60px] w-[115px] rounded-md ${airplane? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${airplane? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-solid fa-plane"></i>
            </span>
            <span className='text-sm pt-1'>Airplane Mode</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{dark? setDark(false): setDark(true)}} className={`h-[60px] w-[115px] rounded-md ${dark? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${dark? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-solid fa-circle-half-stroke"></i>
            </span>
            <span className='text-sm pt-1'>Dark Theme</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{focus? setFocus(false): setFocus(true)}} className={`h-[60px] w-[115px] rounded-md ${focus? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${focus? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-regular fa-moon"></i>
            </span>
            <span className='text-sm pt-1'>Focus Assist</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{location? setLocation(false): setLocation(true)}} className={`h-[60px] w-[115px] rounded-md ${location? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${location? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-solid fa-location-crosshairs"></i>
            </span>
            <span className='text-sm pt-1'>Location</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={nightLightHandle} className={`h-[60px] w-[115px] rounded-md ${night? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${night? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-regular fa-sun"></i>
            </span>
            <span className='text-sm pt-1'>Night Light</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{connect? setConnect(false): setConnect(true)}} className={`h-[60px] w-[115px] rounded-md ${connect? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${connect? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-brands fa-chromecast"></i>
            </span>
            <span className='text-sm pt-1'>Connect</span>
          </div>

          <div className="toggleBtn flex flex-col items-center">
            <span onClick={()=>{transparency?setTransparency(false):setTransparency(true)}} className={`h-[60px] w-[115px] rounded-md ${transparency? 'bg-[#0a84ff]': 'bg-white'} flex justify-center items-center text-xl ${transparency? 'text-white': 'text-black'} transition-all ease-in-out delay-75`}>
              <i className="iBtn fa-regular fa-square"></i>
            </span>
            <span className='text-sm pt-1'>Transparency</span>
          </div>

        </div>

        <div className="sliders px-2 py-5 space-y-6">
          <div className="brightness flex items-cente transition-all ease-in-out delay-75r">
            <span className='mr-3 text-xl'><i className="fa-solid fa-sun m-right"></i>
            </span>
            <input onChange={handleBrightness} className='w-full' type="range" name="brightness" min="10" max="100" />
            <span>{brightness}</span>
          </div>

          <div className="volume flex items-cente transition-all ease-in-out delay-75r">
            <span className='mr-3 text-xl'><i className="fa-solid fa-volume-high m-right"></i>
            </span>
            <input onChange={handleVolume} className='w-full' type="range" name="volume" id="volume" min="1" max="10" />
            {volume}
          </div>
        </div>

        <div className="bottomBar flex items-center justify-between px-2">
          <div className="battery flex items-center">
            <img className="batteryico w-[40px] mr-1" src={batteryico} alt="" />
            <span>100%</span>
          </div>
          
          <div className="settin transition-all ease-in-out delay-75g">
            <span className='text-xl'><i className="fa-solid fa-gear"></i>
            </span>
          </div>
        </div>

      </div>
    </div>
  )
}

export default RightNavPanel
